module.exports = __webpack_public_path__ + "static/img/4.f8f6f88b.jpg";